<template>
	<div class="image-manager-wrap">
		<Modal 
			@close="close"
			class="image-manager"
			title="Image Manager"
			:width="1000"
		>
			<template #content>
				
				<div v-if="showReportLibrary" class="tab-navigation">
					<button
						:class="['tab-button', { active: activeTab === 'uploaded' }]"
						@click="switchTab('uploaded')"
					>
						Your Images
					</button>
					<button
						:class="['tab-button', { active: activeTab === 'library' }]"
						@click="switchTab('library')"
					>
						Report Background Library
					</button>
				</div>

				<div v-if="!showReportLibrary || activeTab === 'uploaded'" class="uploaded-section">
					<div class="upload-image-wrap"><span class="large-button mini upload-image" @click="showUploader = true">Upload a new Image</span></div>
					
					<div :class="{'image-gallery':true,selectable:selectable}" v-if="images.length">
					<div v-for="(image, index) in images" :key="index" class="image-item" @click="selectImage(image)">
						<div class="image-preview">
							<div class="img"><img :src="dir+image.thumbnail" :alt="image.name" /></div>
							<span class="select"><span>Select image</span></span>
							<div class="image-actions">
								<button class="delete-btn" @click="removeImage(image)" title="Delete image">
									<span>×</span>
								</button>
							</div>
						</div>
						<span class="image-name">{{ image.name }}</span>
					</div>
				</div>

				<div v-else class="no-images" v-html="noImagesText" />
			</div>

			<div v-if="showReportLibrary && activeTab === 'library'" class="library-section">
				<div v-if="loadingLibrary" class="loading-library">
					Loading image library...
				</div>
				<div v-else-if="libraryImages.length" :class="{'image-gallery library-gallery':true,selectable:selectable}">
					<div v-for="(image, index) in libraryImages" :key="'lib-' + index" class="image-item library-item" @click="selectLibraryImage(image)">
						<div class="image-preview library-preview">
							<div class="img"><img :src="image.url" :alt="image.name" /></div>
							<span class="select"><span>Select image</span></span>
						</div>
					</div>
				</div>
				<div v-else class="no-images">
					No library images available
				</div>
			</div>
					
			</template>
		</Modal>
		<Uploader 
			v-if="showUploader" 
			:multiple="false" 
			@close-uploader="closeUploader"
			title="Image Upload"
			:fileTypes="['image']"
			:formData="uploadFormData"
			class="image-uploader"
		/>
	</div>
</template>

<script>
	import ApiService from "../services/api.service";
	import Uploader from "./Uploader.vue";
	import Icon from "./Display/Icon.vue"
	import Modal from "./Display/Modal.vue"
	import general from "../utils/general";
	export default {
		name: "ImageManager",
		components: {
			Uploader,
			Icon,
			Modal
		},

		props: {
			selectable:{
				type: Boolean,
				default: false
			},
			autoSelectUploaded: {
				type: Boolean,
				default: false
			},
			showReportLibrary: {
				type: Boolean,
				default: false
			},
			defaultTab: {
				type: String,
				default: 'uploaded',
				validator: value => ['uploaded', 'library'].includes(value)
			}
		},

		data() {
			return {
				images: [],
				dir: '',
				loading: false,
				showUploader: false,
				activeTab: this.showReportLibrary ? this.defaultTab : 'uploaded',
				libraryImages: [],
				loadingLibrary: false
			};
		},

		computed: {
			hasImages() {

				return this.images.length > 0;

			},
			uploadFormData () {

				return { type: 'image', vars:{ save: true } };

			},
			noImagesText () {
				return this.loading ? 'Loading images...' : 'No images uploaded yet';
			}
		},

		methods: {
			close() {
				this.$emit('close');
			},
			closeUploader(data) {
				this.showUploader = false;
				console.log('closeUploader',data);
				if ( data ) {
					this.getImages (data._id);
				}
			},
			switchTab(tab) {
				this.activeTab = tab;
				if (tab === 'library' && this.libraryImages.length === 0) {
					this.getLibraryImages();
				}
			},
			removeImage(image) {

				this.$dialog
					.confirm("Delete this image?", { okText: "Yes", cancelText: "Cancel" })
					.then(
						function() {

							ApiService.delete(`images/${image._id}`)
								.then(
									function(info) {
										if ( info.data.deleted ) {
											this.getImages ();
										}
										else {this.selectable
											if ( info.data.foundIn ) {
												let places = [];
												info.data.foundIn.forEach(place => {
													places.push( `${place.reportName}: ${place.componentName}` );
													
												});
												general.$snotify (this,'html-error',"Couldn't delete image","Image in use: <br>" + places.join("<br>"))
											}
											else {
												this.$snotify.error("Error deleting image", "Couldn't delete image");
											}
										}
									}.bind(this)
								)
								.catch(
									function(err) {
										this.$snotify.error("Error deleting image", "Couldn't delete image");
									}.bind(this)
								);

						}.bind(this)
					)
					.catch(function() {});
			},
			async getImages ( selectId ) {
				try {
					this.loading = true;
					let response = await ApiService.get( `images` );
					this.images = response.data.items;
					this.dir = response.data.dir;
					this.loading = false;
					if ( selectId && this.autoSelectUploaded && this.selectable ) {
						this.selectImage(this.images.find(image => image._id === selectId));
					}
				}
				catch ( err ) {
					this.loading = false;
					this.$snotify.error("Error loading images", "Couldn't load images");
				}
				
			},
			selectImage(image) {
				if ( this.selectable) {
					this.$emit('selected',{ _id: image._id, thumbnail: this.dir + image.thumbnail, ext: image.ext });
					this.close();
				}
			},
			async getLibraryImages() {
				try {
					this.loadingLibrary = true;
					const response = await ApiService.get('images/library');
					this.libraryImages = response.data;
					this.loadingLibrary = false;
				} catch (error) {
					this.loadingLibrary = false;
					this.$snotify.error("Error loading library images", "Couldn't load library images");
					console.error("Error loading library images:", error);
				}
			},
			selectLibraryImage(image) {
				if (this.selectable) {
					// For library images, we need to structure the response differently
					// since they don't have database IDs but have direct URLs
					this.$emit('selected', {
						_id: null, // Library images don't have database IDs
						thumbnail: image.url,
						url: image.url, // Full URL for library images
						ext: image.ext,
						isLibraryImage: true, // Flag to identify library images
						name: image.name
					});
					this.close();
				}
			}
		},

		mounted() {
			this.getImages ();
			if (this.showReportLibrary && this.defaultTab === 'library') {
				this.activeTab = 'library';
				this.getLibraryImages();
			}
		},
	};
</script>

<style lang="less" scoped>
	@import "./../assets/css/less/_helper.less";
	@import "./../assets/css/less/_settings.less";

	.upload-image-wrap {
		text-align: center;
		.upload-image {
			margin: 0;
			font-size: 18px;
		}
	}

	.tab-navigation {
		display: flex;
		margin: 0 0 1rem;
		border-bottom: 2px solid #e0e0e0;

		.tab-button {
			padding: 0.75rem 1.5rem;
			background: none;
			border: none;
			cursor: pointer;
			font-size: 1rem;
			color: #666;
			border-bottom: 2px solid transparent;
			transition: all 0.3s ease;

			&:hover {
				color: @formDefaultColour;
				background-color: rgba(0, 0, 0, 0.05);
			}

			&.active {
				color: @formDefaultColour;
				border-bottom-color: @formDefaultColour;
				font-weight: 600;
			}
		}
	}

	.image-manager {
		.image-gallery {
			display: grid;
			grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
			gap: 1rem;
			margin-top: 1rem;

			&.library-gallery {
				grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
				gap: 0.75rem;

				.library-item {
					.image-preview.library-preview {
						padding-bottom: 450%; // Aspect ratio for tall images (341x1536 ≈ 1:4.5)
						
						.img {
							img {
								object-fit: contain; // Use contain instead of cover for library images
								width: 100%;
								height: 100%;
							}
						}
					}
				}
			}

			.image-item {
				position: relative;
				text-align: center;

				.image-preview {
					position: relative;
					padding-bottom: 100%;
					background: #f5f5f5;
					border-radius: 4px;
					overflow: hidden;

					.img {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						object-fit: cover;
						display: flex;
						align-content: center;
						justify-content: center;
						img {
							max-width: 100%;
						}
					}

					.image-actions {
						position: absolute;
						top: 0.5rem;
						right: 0.5rem;
						display: none;
					}

					&:hover .image-actions {
						display: block;
					}
				}

				.image-name {
					display: block;
					margin-top: 0.5rem;
					font-size: 0.875rem;
					color: #666;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.select {
					display: none;
					position: absolute;
					align-items: center;
					justify-content: center;
					width: 100%;
					height: 100%;
					background: rgba(255,255,255,0.8);
					span {
						color: @darkContrast;
						display: block;
						text-align: center;
					}
				}
			}

			&.selectable {
				.image-item {
					cursor: pointer;
					&:hover {
						img {
							
						}
						.select {
							display: flex;
						}
					}
				}
			}
		}

		.delete-btn {
			background: rgba(0, 0, 0, 0.5);
			color: white;
			border: none;
			border-radius: 50%;
			width: 24px;
			height: 24px;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;

			span {
				color: inherit;
			}

			&:hover {
				background: rgba(0, 0, 0, 0.7);
			}
		}

		.no-images {
			text-align: center;
			color: #666;
			padding: 2rem;
		}

		.loading-library {
			text-align: center;
			color: #666;
			padding: 2rem;
			font-style: italic;
		}

		.library-section {
			margin-top: 1rem;
		}

		.uploaded-section {
			// Styles for uploaded section if needed
		}
	}
</style>
